import generateGrid from './generate-pattern'
import BLOCKS from '../../../universal/filzfelt/blocks'

export default (id, width, height) => {
  let svg = `<svg viewBox="0 0 ${width} ${height}">`
  const blocks = generateGrid(id, width, height);
  for (const { id, points, x, y, r } of Object.values(blocks)) {
    if (points) {
      const fill = BLOCKS[id].placeholderColor || 'transparent';
      svg += `<g><polygon points="${points.join(' ')}" fill="${fill}" /></g>`
    } else {
      const t = `translate(${x}, ${y})` + (r ? ` rotate(${r[0]}, ${r[1]}, ${r[2]})` : '')
      if (BLOCKS[id].path) {
        svg += `<path transform="${t}" d="${BLOCKS[id].path}" />`
      }
      if (BLOCKS[id].variants && BLOCKS[id].variants['1111']) {
        svg += `<path transform="${t}" d="${BLOCKS[id].variants['1111']}" />`
      }
    }
  }
  svg += `<rect width="${width}" height="${height}" />`
  svg += '</svg>'
  return svg
}



// WEBPACK FOOTER //
// ./src/client/lib/filzfelt/generate-preview.js